import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import Loading from '@/components/loading/loading'

@Component({
  components: {
    Loading
  }
})
export default class CheckoutSumary extends Vue {

  @Prop({ default: () => { } }) validate!: Array<any>
  @Prop({ default: () => { } }) tokenInfo!: Object
  @Prop({ default: null }) cart;
  @Prop({ default: false }) loading;

  @Getter getUser
  @Getter getCountry
  @Getter getCurrentAddress
  @Getter getIsUnderMobile
  @Getter getCurrentProgram

  isAddingComment = false;
  orderComment = "";

  get getCommentButtonLabel() {
    if(this.isAddingComment && !this.orderComment.length) {
      return "Cerrar";
    } else if(!this.isAddingComment && this.orderComment.length) {
      return "Editar comentario";
    } else if(this.isAddingComment && this.orderComment.length) {
      return "Guardar comentario";
    } else {
      return "Añade un comentario a tu orden";
    }
  }

  get getCommentButtonIcon() {
    if(this.isAddingComment && !this.orderComment.length) {
      return "ion-close";
    } else if(!this.isAddingComment && this.orderComment.length) {
      return "ion-edit";
    } else if(this.isAddingComment && this.orderComment.length) {
      return "ion-checkmark"
    } else {
      return "ion-plus";
    }
  }

  get getTotalProducts () {
    if(this.cart && this.cart.subtotal) {
      const price = this.currencyParse(this.cart.subtotal);
      return this.localCurrencyFormat(price);
    }
    return "-";
  }

  get getDeliveryPrice() {
    if(this.cart && this.cart.delivery) {
      const delivery = this.currencyParse(this.cart.delivery);
      return this.localCurrencyFormat(delivery);
    }
    return "-";
  }

  get getTotalProductsDiscount() {
    if(this.cart && this.cart.promo_discount_amount >= 0) {
      const price = parseFloat(this.cart.promo_discount_amount);
      if(price <= 0) {
        return "-";
      } else {
        return "-" + this.localCurrencyFormat(price);
      }
    }
    return "-";
  }

  get getCouponName() {
    if(this.cart && this.cart.coupon && this.cart.coupon_applied) {
      return this.cart.coupon;
    } else {
      return null;
    }
  }

  get isFreeProductsCoupon() {
    if(this.cart && this.cart.coupon_data && this.cart.coupon_applied) {
      return this.cart.coupon_data.coupon_type === 'free_product';
    }
    return false;
  }

  get getFreeProductsValue() {
    if(this.isFreeProductsCoupon && this.cart.discount) {
      return this.localCurrencyFormat(this.cart.discount);
    }
    return false;
  }

  get getCouponDiscount() {
    if (this.cart && this.cart.coupon_applied && this.cart.coupon_data) {
      if (
        this.cart.coupon_data.coupon_type === "percentage_discount" &&
        this.cart.coupon_data.discount
      ) {
        const discount = (parseFloat(this.cart.coupon_data.discount)*this.currencyParse(this.cart.subtotal));
        return "-" + this.localCurrencyFormat(discount);
      } else if(this.cart.coupon_data.coupon_type === "monetary_discount") {
        const discount = (parseFloat(this.cart.coupon_data.discount));
        return "-" + this.localCurrencyFormat(discount);
      } else if (this.cart.coupon_data.coupon_type === 'free_delivery') {
        return "Domicilio Gratis";
      } else if (this.cart.coupon_data.coupon_type === 'free_product') {
        return "Productos Gratis";
      }
    }
  }

  get getTotalDonation () {
    const price = parseFloat(this.cart.total_donation)
    return this.$currency.format(price, { code: this.getCountry.currency })
  }

  get getTotalTC () {
    const donation = parseFloat(this.cart.total_us_donating)
    return this.$currency.format(donation, { code: this.getCountry.currency })
  }

  get getValueTotal () {
    if(this.cart && this.cart.total) {
      const total = this.currencyParse(this.cart.total);
      return this.localCurrencyFormat(total);
    } else {
      return "-";
    }
  }

  get getButtonLabel() {
    let response = "";
    if (this.loading) {
      response = "Cargando...";
    } else if (!this.getCurrentAddress) {
      response = "Agregar Dirección";
    } else if (
      !this.getCurrentProgram ||
      !this.getCurrentProgram.hourRange ||
      !this.getCurrentProgram.day
    ) {
      response = "Programar Entrega";
    } else {
      response = "Enviar Pedido";
    }
    return response;
  }

  @Watch('orderComment')
  onOrderComment() {
    this.$emit('onOrderComment', this.orderComment);
  }

  private localCurrencyFormat(value) {
    if(this.getCountry && this.getCountry.currency) {
      return this.$currency.format(value, { code: this.getCountry.currency });
    }
    return value;
  }

  private currencyParse(value) {
    if (value.indexOf(".") !== -1) {
      value = value.split(".")[0];
      value = value.replace("$", "");
      value = value.replace(",", "");
      return parseFloat(value);
    }
    return value;
  }

  onMainButtonClick() {
    if (!this.loading) {
      if (!this.getCurrentAddress) {
        this.$emit("onAddAddress");
      } else if (
        !this.getCurrentProgram ||
        !this.getCurrentProgram.hourRange ||
        !this.getCurrentProgram.day
      ) {
        this.$emit('onAddProgram');
        
      } else {
        this.$emit("onCompleteOrder");
      }
    }
  }

  noDocType() {
    alert('Debes agregar un documento de identidad')
  }

  addEditOrderComment() {
    this.isAddingComment = !this.isAddingComment;
  }

}
